import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { AdminApiCtx, createAdminHttpApi } from "@/api/adminClient";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AdminApiCtx.Provider value={createAdminHttpApi()}>
        <App />
      </AdminApiCtx.Provider>
    </BrowserRouter>
  </StrictMode>,
);
